import { motion } from 'framer-motion'
import { AnimatePresence } from 'framer-motion'

import CreatorCard from '@/molecules/CreatorCard'
import Creator from '@/ts/Creator'

import css from '../scss/index.module.scss'

function CreatorsGrid({ creators }: { creators: Creator[] }) {
  return (
    <div className={css['creators-grid']}>
      <AnimatePresence>
        {creators?.map((creator) => (
          <motion.article key={creator.id} {...animation}>
            <CreatorCard creator={creator} layout="grid" />
          </motion.article>
        ))}
      </AnimatePresence>
    </div>
  )
}

const animation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}

export default CreatorsGrid
